<p-menubar
  [model]="menuBarItems"
  [autoDisplay]="false"
  styleClass="surface-ground gap-2">
  <ng-template pTemplate="start">
    <div class="flex gap-2">
      <p-button
        (click)="goToLandingpage()"
        [rounded]="true"
        icon="fas fa-home"></p-button>
      @if (
        topicItems && topicItems.length > 0 && globalStore.activeTopic();
        as topic
      ) {
        <p-button
          severity="info"
          (onClick)="menu.toggle($event)"
          [rounded]="true"
          [icon]="'fas fa-' + topic.icon"></p-button>

        <p-menu #menu [model]="topicItems" [popup]="true" />
      }
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <a
      pRipple
      class="flex align-items-center p-menuitem-link gap-2"
      [routerLink]="item.routerLink || null"
      [routerLinkActive]="'p-menuitem-link-active'"
      [pTooltip]="item.pTooltip">
      @if (item.icon) {
        <span [class]="item.icon"></span>
      }
      <span class="p-menuitem-text">{{ item.label }}</span>
      @if (item.items && item.items.length > 0) {
        <i class="fas fa-chevron-down text-xs"></i>
      }
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="justify-content-end flex flex-1 align-items-center gap-2">
      @if (
        activeUserStore.context() !== 'atlasExternal' &&
        activeUserStore.canAccessEntityAdder()
      ) {
        @for (item of topItems; track $index) {
          <p-splitButton
            [rounded]="true"
            size="small"
            [icon]="item.icon"
            (onClick)="quickSave()"
            [model]="item.items">
            <ng-template pTemplate="dropdownicon">
              <i class="fas fa-chevron-down"></i>
            </ng-template>
          </p-splitButton>
        }
      }

      <app-theme-switcher></app-theme-switcher>
      <app-atlas-search></app-atlas-search>
      <p-menu #menu [model]="miscItems" [popup]="true" styleClass="w-20rem">
        <ng-template pTemplate="item" let-item>
          @if (item.url) {
            <a class="p-menuitem-link" target="_blank" [href]="item.url">
              <div class="flex align-items-center">
                <i class="p-menuitem-icon" [class]="item.icon"></i>
                <div>
                  <span>{{ item.label }}</span>
                  @if (item.sub) {
                    <div class="text-xs text-color-secondary mt-2">
                      {{ item.sub }}
                    </div>
                  }
                </div>
              </div>
            </a>
          } @else {
            <a
              class="p-menuitem-link"
              [routerLink]="item.routerLink"
              [target]="item.target || '_self'">
              <div class="flex align-items-center">
                <i class="p-menuitem-icon" [class]="item.icon"></i>
                <div>
                  <span>{{ item.label }}</span>
                  @if (item.sub) {
                    <div class="text-xs text-color-secondary mt-2">
                      {{ item.sub }}
                    </div>
                  }
                </div>
              </div>
            </a>
          }
        </ng-template>
      </p-menu>

      <p-button
        [rounded]="true"
        size="small"
        [text]="true"
        (onClick)="menu.toggle($event)"
        icon="fas fa-ellipsis-vertical" />
      <app-active-user-avatar
        [addBookmarks]="true"
        styleClass="ml-2"></app-active-user-avatar>
    </div>
  </ng-template>
</p-menubar>
<p-confirmDialog key="overwriteBookmark" #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-floppy-disk"
        [text]="message.header"></app-header>

      <div class="flex">
        Ihre Ansicht wird mit der aktuellen Ansicht überschrieben.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="ja, speichern"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
